var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1785_3486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.8125H15.75V0.9375H0.75V2.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 6.5625H13.875V4.6875H2.625V6.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.3125H12V8.4375H4.5V10.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 14.0625H6.375V12.1875H10.125V14.0625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1785_3486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.5e582f0c7a4882be862de489300b87d7.svg";
export { ForwardRef as ReactComponent };